import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props}>
    <path d='M3 3v18h18V3H3zm16 16H5V5h14v14z' />
  </SvgIcon>
)
